export default class PlaningConfig {
	constructor(
		public SelectedGroups: number[] = [], 
		public SelectedView: string = null,
		public SelectedUsers: number[] = []
	) {}

	public static parse(o: object): PlaningConfig {
		const ret = new PlaningConfig();
		Object.assign(ret, o);
		return ret;
	}
}
